import { Box, CircularProgress } from '@mui/material'

function LoadingScreen() {
  return <>
      <Box sx={{ display: 'flex', justifyContent:'center', alignItems:'center', height:'100vh' }}>
        <CircularProgress sx={{color:'#FD8204'}} />
      </Box>
  </>
}

export default LoadingScreen